import { useEffect } from 'react';

/**
 * Warms the connection to Google Fonts so the first paint isn't blocked
 * waiting on DNS/TLS. The hero image is bundled by Vite (content-hashed)
 * and loaded eagerly with fetchPriority="high" directly in HeroSection,
 * so it does not need a manual preload here.
 */
export const PreloadResources = () => {
  useEffect(() => {
    const preconnects = [
      { href: 'https://fonts.googleapis.com', crossOrigin: false },
      { href: 'https://fonts.gstatic.com', crossOrigin: true },
    ];

    const created: HTMLLinkElement[] = [];
    preconnects.forEach(({ href, crossOrigin }) => {
      if (document.querySelector(`link[rel="preconnect"][href="${href}"]`)) return;
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      if (crossOrigin) link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
      created.push(link);
    });

    return () => {
      created.forEach((link) => link.remove());
    };
  }, []);

  return null;
};

export default PreloadResources;
